import TaskHistoryActionTypes from 'app/history/ActionTypes';
import routes from 'app/history/routes';

export default {
  actionTypes: TaskHistoryActionTypes,
  routes,
};
